import React from "react";

import { styled } from "@mui/material/styles";

interface ILoginBoxContentProps {
  children: React.ReactNode;
}

const StyledDiv = styled("div")(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

const LoginBoxContent = (props: ILoginBoxContentProps) => {
  const { children } = props;

  return <StyledDiv>{children}</StyledDiv>;
};

export default LoginBoxContent;
